<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">中山市固体废物在线监控管理平台</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              2017年中山市工业企业危险废物转移量为17.13万吨，纳入危险废物规范化管理的企业共3548家，其中危险废物产生量10吨以上的重点企业有207家，危险废物产生量占2017年危险废物总产生量的98%以上。目前，中山市共有6家工业危险废物经营单位（另有4家准备建设中），包括1家生活垃圾焚烧飞灰填埋场，1家危险废物收集储运公司和4家危险废物经营单位。另有一般工业固体废物经营单位1家，主要处置生活污水厂污泥，为加强对一般工业固体废物的监管，将该污泥处置厂也纳入平台进行监管，列入经营单位范围。2017年医疗废物产生量为3993吨，中山市10床以上医疗机构共有67家，其医疗废物产生量占全市医疗废物总产生量的89%以上。现中山市有1家医疗废物焚烧厂。
            </div>
             <div class="section">
              固体废物在线监控管理平台实现对固体废物、尤其是危险废物从产生、收集、贮存、运输和处理处置等环节的全生命周期监管，并应用视频监视、GPS跟踪、卫星遥感等技术手段，形成点、线、面全方位的立体监控网络。通过分析决策和辅助执法功能模块的设置，降低对现场监察人员的专业性要求，提高监管的效率、精准性和一致性，在不大幅增加管理部门工作人员情况下更高效、高质地开展环境监管工作。
            </div>

            <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/1.png" alt="" />
            </div>
             <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/2.png" alt="" />
            </div>
             <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/3.png" alt="" />
            </div>
             <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/4.png" alt="" />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            利用物联网技术，对企业信息进行管理，规范其基础信息，收集企业工况信息，为信息的备案提供媒介。
          </div>
          <div class="section">
            结合GPS、GIS等功能完成运输车辆的转移过程监管，并结合固废转移电子联单，推行固废转移运输全过程定位跟踪监控，及时汇集全流向、闭环化的危险废物信息数据，实现危险废物全生命周期信息共享和全面监管。
          </div>
          <div class="section">
            建立了固废数据中心用于存储固废相关业务办理过程中所产生的庞大数据，并合理的运用该数据进行分析，为固废管理部门提供决策支持
          </div>
          <div class="section">
            整合现有的固废监管数据（原有系统、文件内数据等），实现了固体废物管理从“摇篮”到“坟墓”的全过程监管。
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseZhongZaiShengDetail4",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZhongZaiShengDetail4.vue